import React, { Component } from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import AboutUs from './Components/AboutUs'
import News from './Components/News'
import Products from './Components/Products'
import References from './Components/References'
import { Helmet } from "react-helmet";
import Mushroom from './Components/Mushroom';
import MushroomProducts from './Components/MushroomProducts'
import { selectPopupStatus } from '../store/selectors'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import FairModal from '../components/FairModal'
import { Catalogs } from './Components/Catalogs'


class HomePage extends Component {

    componentDidMount = () => {
        document.documentElement.lang = "tr";
    }

    render() {
        return (

            <div>
                <Helmet>
                    <meta http-equiv="content-language" content="tr" />
                    <title data-react-helmet="true">
                        TMS AR-GE | TMS Tren Bakım Onarım A.Ş.
                    </title>
                    <meta
                        name="description"
                        content="TMS AR-GE | TMS ARGE Ekibi olarak projelerimizi görmek ve TMS ARGE ekibini tanımak için hemen sitemizi ziyaret edin | TMS Tren Bakım Onarım A.Ş."
                        data-react-helmet="true"
                    />
                    <meta name="keywords" content="TMS Ar-Ge" data-react-helmet="true" />

                    <link rel="canonical" href="https://www.tmsarge.com/" />
                    <link rel="alternate" hreflang="tr" href="https://www.tmsarge.com/" />
                    <link rel="alternate" hreflang="en" href="https://www.tmsarge.com/eng" />
                    <link rel="alternate" hreflang="de" href="https://www.tmsarge.com/de" />
                    <link rel="alternate" hreflang="x-default" href="https://www.tmsarge.com/" />

                </Helmet>

                <Navbar />

                <div className='header-parts' id='homepage'>
                    <div className="header-part">
                        <h3 className="">TMS AR-GE</h3>
                        <p className="">Yenilik, Modern, Yaratıcı ve Son Teknoloji</p>
                        <a href="#about-us" className="btn btn-outline-light btn-lg mt-4" type="button">
                            Daha Fazla
                        </a>
                    </div>
                    <div className="header-part">
                        <Mushroom />
                    </div>
                </div>
                <div className="an">
                    <AboutUs />
                    <News />
                </div>

                <Catalogs />

                <MushroomProducts />

                <Products />

                <References />

                <Footer />

                {this.props.isPopupShow && <FairModal />}

            </div>

        )
    }
};

const mapStateToProps = createStructuredSelector({
    isPopupShow: selectPopupStatus()
});

export default connect(mapStateToProps)(HomePage);